var _g, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0597 6.11133C20.5544 6.11133 20.9543 6.51213 20.9543 7.00598C20.9543 7.49983 20.5544 7.90063 20.0597 7.90063H13.5978C13.1039 7.90063 12.7031 7.49983 12.7031 7.00598C12.7031 6.51213 13.1039 6.11133 13.5978 6.11133H20.0597Z",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.85947 16.0957H11.3222C11.817 16.0957 12.2169 16.4965 12.2169 16.9904C12.2169 17.4842 11.817 17.885 11.3222 17.885H4.85947C4.36564 17.885 3.96484 17.4842 3.96484 16.9904C3.96484 16.4965 4.36564 16.0957 4.85947 16.0957Z",
    fill: "#484848"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91918 6.89912C9.91918 8.5426 8.58259 9.87921 6.94005 9.87921C5.29751 9.87921 3.96094 8.5426 3.96094 6.89912C3.96094 5.25653 5.29751 3.91992 6.94005 3.91992C8.58259 3.91992 9.91918 5.25653 9.91918 6.89912Z",
    fill: "#484848",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 17.1051C15 15.4616 16.3366 14.125 17.9791 14.125C19.6225 14.125 20.9591 15.4616 20.9591 17.1051C20.9591 18.7477 19.6225 20.0843 17.9791 20.0843C16.3366 20.0843 15 18.7477 15 17.1051Z",
    fill: "#484848",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter1);
export default __webpack_public_path__ + "static/media/Filter 1.56ae0d847e73b0e6985f6bc639c13ff4.svg";
export { ForwardRef as ReactComponent };